import type { TextListField } from "./api/CrmApi";

/** The three narrative lists a company page shows and edits (Group C step 4b). Advisory: Claude reads them against the
 *  RFP's past-performance, project-size and domestic-performance requirements; they never exclude a company. */
export const TEXT_LISTS: Record<TextListField, {
  title: string; edit: string; hint: string; placeholder: string; empty: string; testid: string;
}> = {
  past_performance: {
    title: "Past performance", edit: "Edit past performance", testid: "past-performance",
    hint: "Named customers and engagements, with dollar figures and years where known — one entry per box. Read against the RFP's reference requirements.",
    placeholder: "e.g. Built the county CAD system for Hillsborough County (2022–2025, $2.1M).",
    empty: "No past performance yet.",
  },
  project_size: {
    title: "Project size", edit: "Edit project size", testid: "project-size",
    hint: "The size of work this company takes on: typical contract values, terms, team sizes. Read against the RFP's value and term.",
    placeholder: "e.g. Typical engagements run $500K to $3M over 12–24 months.",
    empty: "No project size yet.",
  },
  domestic_performance: {
    title: "Domestic performance", edit: "Edit domestic performance", testid: "domestic-performance",
    hint: "Where this company delivers from: US offices, staffing, onshore delivery. Read against the RFP's US-only or onshore requirement.",
    placeholder: "e.g. All delivery is from its Tampa, Florida office with US-based staff.",
    empty: "No domestic performance yet.",
  },
};

export const TEXT_LIST_FIELDS = Object.keys(TEXT_LISTS) as TextListField[];
